// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see SettingsEligibilityRetrieveStartedEvent
 */
export var SettingsEligibilityRetrieveStarted = function (_a) {
    var policyChangeTimestamp = _a.policyChangeTimestamp, originDescription = _a.originDescription, attemptNumber = _a.attemptNumber;
    return ({
        name: "SettingsEligibility Retrieve Started",
        parameters: {
            cdf_entity: "SettingsEligibility",
            cdf_action: "Retrieve",
            policy_change_timestamp: policyChangeTimestamp !== undefined && policyChangeTimestamp !== null ? policyChangeTimestamp.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin_description: originDescription !== undefined && originDescription !== null ? originDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            attempt_number: attemptNumber !== undefined && attemptNumber !== null ? attemptNumber.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SettingsEligibilityRetrieveSucceededEvent
 */
export var SettingsEligibilityRetrieveSucceeded = function (_a) {
    var policyChangeTimestamp = _a.policyChangeTimestamp, originDescription = _a.originDescription, attemptNumber = _a.attemptNumber, localValues = _a.localValues, remoteValues = _a.remoteValues;
    return ({
        name: "SettingsEligibility Retrieve Succeeded",
        parameters: {
            cdf_entity: "SettingsEligibility",
            cdf_action: "Retrieve",
            policy_change_timestamp: policyChangeTimestamp !== undefined && policyChangeTimestamp !== null ? policyChangeTimestamp.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin_description: originDescription !== undefined && originDescription !== null ? originDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            attempt_number: attemptNumber !== undefined && attemptNumber !== null ? attemptNumber.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            local_values: localValues !== undefined && localValues !== null ? localValues.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            remote_values: remoteValues !== undefined && remoteValues !== null ? remoteValues.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SettingsEligibilityRetrieveUnchangedEvent
 */
export var SettingsEligibilityRetrieveUnchanged = function (_a) {
    var policyChangeTimestamp = _a.policyChangeTimestamp, originDescription = _a.originDescription, attemptNumber = _a.attemptNumber;
    return ({
        name: "SettingsEligibility Retrieve Unchanged",
        parameters: {
            cdf_entity: "SettingsEligibility",
            cdf_action: "Retrieve",
            policy_change_timestamp: policyChangeTimestamp !== undefined && policyChangeTimestamp !== null ? policyChangeTimestamp.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin_description: originDescription !== undefined && originDescription !== null ? originDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            attempt_number: attemptNumber !== undefined && attemptNumber !== null ? attemptNumber.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SettingsEligibilityRetrieveCanceledEvent
 */
export var SettingsEligibilityRetrieveCanceled = function (_a) {
    var reason = _a.reason, policyChangeTimestamp = _a.policyChangeTimestamp, originDescription = _a.originDescription, attemptNumber = _a.attemptNumber;
    return ({
        name: "SettingsEligibility Retrieve Canceled",
        parameters: {
            cdf_entity: "SettingsEligibility",
            cdf_action: "Retrieve",
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            policy_change_timestamp: policyChangeTimestamp !== undefined && policyChangeTimestamp !== null ? policyChangeTimestamp.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin_description: originDescription !== undefined && originDescription !== null ? originDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            attempt_number: attemptNumber !== undefined && attemptNumber !== null ? attemptNumber.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SettingsEligibilityRetrieveFailedEvent
 */
export var SettingsEligibilityRetrieveFailed = function (_a) {
    var reason = _a.reason, policyChangeTimestamp = _a.policyChangeTimestamp, originDescription = _a.originDescription, attemptNumber = _a.attemptNumber;
    return ({
        name: "SettingsEligibility Retrieve Failed",
        parameters: {
            cdf_entity: "SettingsEligibility",
            cdf_action: "Retrieve",
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            policy_change_timestamp: policyChangeTimestamp !== undefined && policyChangeTimestamp !== null ? policyChangeTimestamp.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin_description: originDescription !== undefined && originDescription !== null ? originDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            attempt_number: attemptNumber !== undefined && attemptNumber !== null ? attemptNumber.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
